module.exports = __webpack_public_path__ + "static/media/05_control_interface.5cc87c41.png";